import { render, staticRenderFns } from "./syncUser.vue?vue&type=template&id=d0c2b34a"
import script from "./syncUser.vue?vue&type=script&lang=js"
export * from "./syncUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports